import HomeBasicInfo from "./HomeBasicInfo";

export default HomeBasicInfo;
export { HomeBasicInfo };
